export default {
  TO_DO: { value: 1, title: "ToDo", class: ["blue-grey", "lighten-4"] },
  DISPUTE: { value: 2, title: "Dispute", class: ["yellow", "lighten-3"] },
  IN_PROGRESS: { value: 3, title: "InProgress", class: ["light-blue", "lighten-3"] },
  DONE: { value: 4, title: "Done", class: ["green", "accent-3"] },
};